import React from 'react';
import { ExternalLink, Phone, MessageSquare, FileText } from 'lucide-react';
export function LinksAndResources() {
  return <div className="min-h-screen bg-white pt-40 lg:pt-52 pb-20" data-id="element-1045">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1046">
        {/* Page Header */}
        <div className="text-center mb-12" data-id="element-1047">
          <h1 className="text-4xl font-bold text-gray-900 mb-2" data-id="element-1048">
            LINKS & RESOURCES
          </h1>
        </div>

        {/* ADRE and other Useful Links Section */}
        <div className="mb-12" data-id="element-1049">
          <h2 className="text-3xl font-bold text-[#fcb53d] mb-8" data-id="element-1050">
            ADRE and other Useful Links
          </h2>

          {/* Student Log-In Link */}
          <div className="mb-6" data-id="element-1051">
            <p className="text-base" data-id="element-1052">
              <span className="text-green-600 font-bold italic" data-id="element-1053">
                Go Back To Student Log-In
              </span>{' '}
              <a href="http://www.desertsageseminars.com/Home.html" target="_blank" rel="noopener noreferrer" className="text-green-600 hover:text-green-700 underline" data-id="element-1054">
                http://www.desertsageseminars.com/Home.html
              </a>
            </p>
          </div>

          {/* ADRE Contact */}
          <div className="mb-6" data-id="element-1055">
            <p className="text-base font-bold italic" data-id="element-1056">
              Arizona Department of Real Estate (ADRE) 602-771-7799
            </p>
          </div>
        </div>

        {/* QUESTIONS FOR ADRE Section */}
        <div className="bg-gray-50 px-8 py-10 mb-12 rounded-lg border border-gray-200" data-id="element-1057">
          <h2 className="text-3xl font-bold text-[#fcb53d] mb-8" data-id="element-1058">
            QUESTIONS FOR ADRE?
          </h2>

          <div className="space-y-6" data-id="element-1059">
            {/* Find Your License Number */}
            <div className="pb-6 border-b border-gray-200" data-id="element-1060">
              <p className="text-base font-bold italic mb-2" data-id="element-1061">
                *Find Your License Number
              </p>
              <a href="http://services.azre.gov/publicdatabase/SearchIndividuals.aspx" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1062">
                http://services.azre.gov/publicdatabase/SearchIndividuals.aspx
                <ExternalLink className="w-4 h-4 ml-1" data-id="element-1063" />
              </a>
            </div>

            {/* Enter CE Classes */}
            <div className="pb-6 border-b border-gray-200" data-id="element-1064">
              <p className="text-base font-bold italic mb-2" data-id="element-1065">
                *Report CE Classes To ADRE
              </p>
              <p className="text-sm text-gray-600 mb-2" data-id="element-1066">
                (have your license number ready to create or log in to account):
              </p>
              <a href="/How_To_Add_CE_Classes" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1067">
                View Reporting Instructions
              </a>
            </div>

            {/* ADRE Fee Schedule */}
            <div className="pb-6 border-b border-gray-200" data-id="element-1068">
              <p className="text-base font-bold italic mb-2" data-id="element-1069">
                *Fees to renew AZ real estate license:
              </p>
              <a href="https://azre.gov/all-adre-resources/fees" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1070">
                https://azre.gov/all-adre-resources/fees
                <ExternalLink className="w-4 h-4 ml-1" data-id="element-1071" />
              </a>
            </div>

            {/* Log in or update */}
            <div data-id="element-1072">
              <p className="text-base font-bold italic mb-2" data-id="element-1073">
                *Log in or update your personal information at ADRE or :
              </p>
              <a href="https://ptl.az.gov/app/dre/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1074">
                https://ptl.az.gov/app/dre/
                <ExternalLink className="w-4 h-4 ml-1" data-id="element-1075" />
              </a>
            </div>
          </div>
        </div>

        {/* Tech Helpline Section */}
        <div className="mb-12 bg-white rounded-lg border-2 border-gray-200 p-8" data-id="element-1076">
          <h2 className="text-3xl font-bold text-[#fcb53d] mb-6" data-id="element-1077">
            Tech Helpline
          </h2>
          <p className="text-base text-gray-900 mb-6" data-id="element-1078">
            <strong data-id="element-1079">Arizona Department of Real Estate (ADRE)</strong>{' '}
            602-771-7799
          </p>

          <div className="space-y-4" data-id="element-1080">
            <p className="text-lg text-gray-900" data-id="element-1081">
              Did you know that you can get tech help for ALL of your devices?
            </p>
            <p className="text-lg text-gray-900 ml-10" data-id="element-1082">
              It's "free"... paid for with your{' '}
              <strong data-id="element-1083">
                REALTOR<sup data-id="element-1084">®</sup>
              </strong>{' '}
              dues!
            </p>

            <div className="mt-6 bg-gray-50 p-6 rounded-lg" data-id="element-1085">
              <p className="text-base font-bold text-gray-900 mb-3" data-id="element-1086">
                Contact Tech HelpLine:
              </p>
              <div className="space-y-2" data-id="element-1087">
                <p className="text-base text-gray-900" data-id="element-1088">
                  <strong data-id="element-1089">Phone:</strong> (866) 232-1791
                </p>
                <p className="text-base text-gray-900" data-id="element-1090">
                  <strong data-id="element-1091">Online chat or support:</strong>{' '}
                  <a href="http://chat.techhelpline.com" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 underline" data-id="element-1092">
                    http://chat.techhelpline.com
                  </a>
                </p>
              </div>
            </div>

            <div className="mt-6 bg-gray-50 p-6 rounded-lg" data-id="element-1093">
              <p className="text-base font-bold text-gray-900 mb-3" data-id="element-1094">Hours:</p>
              <div className="space-y-1" data-id="element-1095">
                <p className="text-base text-gray-900" data-id="element-1096">
                  Monday through Friday—9 am to 8 pm, Eastern Time
                </p>
                <p className="text-base text-gray-900" data-id="element-1097">
                  Saturday—9 am to 5 pm, Eastern Time
                </p>
                <p className="text-base text-gray-900" data-id="element-1098">Sunday—closed</p>
              </div>
            </div>
          </div>
        </div>

        {/* Residential Landlord/Tenant Act Section */}
        <div className="bg-gray-50 px-8 py-10 mb-12 rounded-lg border border-gray-200" data-id="element-1099">
          <h2 className="text-2xl font-bold mb-4" data-id="element-1100">
            <a href="https://housing.az.gov/sites/default/files/documents/files/Landlord_Tenant_Act_May-2023_1.pdf" target="_blank" rel="noopener noreferrer" className="text-[#fcb53d] hover:text-[#e5a436] inline-flex items-center" data-id="element-1101">
              Residential Landlord/Tenant Act
              <ExternalLink className="w-5 h-5 ml-2" data-id="element-1102" />
            </a>
          </h2>

          <p className="text-base text-gray-700" data-id="element-1103">
            This is the text of the Arizona Statute that provides the rights and
            obligations of landlords and tenants in residential properties.
          </p>
        </div>

        {/* Other Useful Sites Section */}
        <div className="mb-12" data-id="element-1104">
          <h2 className="text-3xl font-bold text-[#fcb53d] mb-8" data-id="element-1105">
            Other Useful Sites-click for links:
          </h2>

          {/* Federal Government/National Sites */}
          <div className="mb-10 bg-white rounded-lg border-2 border-gray-200 p-8" data-id="element-1106">
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-1107">
              Federal Government/National Sites
            </h3>
            <ul className="space-y-3" data-id="element-1108">
              <li className="text-base" data-id="element-1109">
                <a href="https://www.consumerfinance.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1110">
                  Consumer Financial Protection Bureau (CFPB)
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1111" />
                </a>
              </li>
              <li className="text-base" data-id="element-1112">
                <a href="https://www.hud.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1113">
                  US Department of Housing and Urban Development (HUD)
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1114" />
                </a>
              </li>
              <li className="text-base" data-id="element-1115">
                <a href="https://www.donotcall.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1116">
                  National Do Not Call Registry
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1117" />
                </a>
              </li>
              <li className="text-base" data-id="element-1118">
                <a href="https://www.va.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1119">
                  Department of Veterans Affairs
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1120" />
                </a>
              </li>
              <li className="text-base" data-id="element-1121">
                <a href="https://www.hudhomestore.com/Home/Index.aspx" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1122">
                  HUD Home Store
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1123" />
                </a>{' '}
                <span className="text-gray-600" data-id="element-1124">
                  (to sell HUD foreclosed properties, check with your broker)
                </span>
              </li>
            </ul>
          </div>

          {/* State of Arizona Sites */}
          <div className="mb-10 bg-white rounded-lg border-2 border-gray-200 p-8" data-id="element-1125">
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-1126">
              State of Arizona Sites
            </h3>
            <ul className="space-y-3" data-id="element-1127">
              <li className="text-base" data-id="element-1128">
                <a href="https://az.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1129">
                  State of Arizona
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1130" />
                </a>
              </li>
              <li className="text-base" data-id="element-1131">
                <a href="https://difi.az.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1132">
                  Department of Financial Institutions
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1133" />
                </a>
              </li>
              <li className="text-base" data-id="element-1134">
                <a href="http://www.azdeq.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1135">
                  Arizona Department of Environmental Quality
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1136" />
                </a>
              </li>
              <li className="text-base" data-id="element-1137">
                <a href="https://azdohs.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1138">
                  Arizona Department of Homeland Security
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1139" />
                </a>
              </li>
              <li className="text-base" data-id="element-1140">
                <a href="https://roc.az.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1141">
                  Arizona Registrar of Contractors
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1142" />
                </a>
              </li>
              <li className="text-base" data-id="element-1143">
                <a href="http://www.azcc.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1144">
                  Arizona Corporation Commission
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1145" />
                </a>
              </li>
              <li className="text-base" data-id="element-1146">
                <a href="https://azsos.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1147">
                  Arizona Secretary of State
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1148" />
                </a>
              </li>
              <li className="text-base" data-id="element-1149">
                <a href="https://www.azag.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1150">
                  Arizona Attorney General
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1151" />
                </a>
              </li>
            </ul>
          </div>

          {/* Arizona County Sites */}
          <div className="bg-white rounded-lg border-2 border-gray-200 p-8" data-id="element-1152">
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-1153">
              Arizona County Sites (partial list)
            </h3>
            <ul className="space-y-3" data-id="element-1154">
              <li className="text-base" data-id="element-1155">
                <a href="http://www.coconino.az.gov/119/Assessor" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1156">
                  Coconino County Assessors Office
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1157" />
                </a>
              </li>
              <li className="text-base" data-id="element-1158">
                <a href="http://www.coconino.az.gov/319/Recorder" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1159">
                  Coconino County Recorders Office
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1160" />
                </a>
              </li>
              <li className="text-base" data-id="element-1161">
                <a href="https://mcassessor.maricopa.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1162">
                  Maricopa County Assessors Office
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1163" />
                </a>
              </li>
              <li className="text-base" data-id="element-1164">
                <a href="https://recorder.maricopa.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1165">
                  Maricopa County Recorders Office
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1166" />
                </a>
              </li>
              <li className="text-base" data-id="element-1167">
                <a href="http://www.asr.pima.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1168">
                  Pima County Assessors Office
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1169" />
                </a>
              </li>
              <li className="text-base" data-id="element-1170">
                <a href="https://www.recorder.pima.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1171">
                  Pima County Recorders Office
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1172" />
                </a>
              </li>
              <li className="text-base" data-id="element-1173">
                <a href="http://www.pinalcountyaz.gov/Assessor/Pages/home.aspx" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1174">
                  Pinal County Assessors Office
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1175" />
                </a>
              </li>
              <li className="text-base" data-id="element-1176">
                <a href="http://www.pinalcountyaz.gov/Recorder/Pages/home.aspx" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1177">
                  Pinal County Recorders Office
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1178" />
                </a>
              </li>
              <li className="text-base" data-id="element-1179">
                <a href="http://www.yumacountyaz.gov/government/assessor" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1180">
                  Yuma County Assessors Office
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1181" />
                </a>
              </li>
              <li className="text-base" data-id="element-1182">
                <a href="http://www.yumacountyaz.gov/government/recorder" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1183">
                  Yuma County Recorders Office
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1184" />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>;
}